import { TPushNotificationAction } from '../../../../store/notification/Actions/push';

// TODO: Remove this file: a better solution is implemented as an action in the notification's store
export const sendSuccessPushNotification = (
  pushNotification: TPushNotificationAction,
  message: string
) => {
  pushNotification({
    status: 'unread',
    text: message || '',
    type: 'success'
  });
};
